import {computed, makeAutoObservable, observable} from "mobx";
import {convertNrsBalanceToDecimal} from "../../stores/LockBalanceStore";

export interface ILockWithdrawal {
    amount: bigint
    startTime: bigint
    endTime: bigint
}

export class DepositWithdrawalLockStore {
    latestUpdateAt = 0;
    public withdrawals: ILockWithdrawal[] = [];

    constructor() {
        makeAutoObservable(this, {
            withdrawals: observable,
            withdrawalsForRender: computed,
            pendingWithdrawalsCount: computed,
            claimableWithdrawalsAmountDecimal: computed,
            isClaimAvailable: computed
        });
    }

    get withdrawalsForRender() {
        return this.withdrawals.map((withdrawal, i) => ({
            id: i,
            amount: withdrawal.amount.toString(),
            endTime: withdrawal.endTime.toString(),
            startTime: withdrawal.startTime.toString()
        }))
    }

    get pendingWithdrawalsCount() {
        return this.withdrawals.length
    }

    get claimableWithdrawalsAmountDecimal() {
        return convertNrsBalanceToDecimal(this.claimableWithdrawalsAmount)
    }

    get requestedWithdrawalsAmountDecimal() {
        return convertNrsBalanceToDecimal(this.requestedWithdrawalsAmount)
    }

    get requestedWithdrawalsAmount() {
        const now = Math.floor(Date.now() / 1000)
        const requestedAmount = this.withdrawals
            .reduce((res, withdrawal) => {
                if (now < Number(withdrawal.endTime)) {
                    res += withdrawal.amount
                }
                return res;
            }, 0n)

        return requestedAmount.toString()
    }

    get claimableWithdrawalsAmount() {
        const now = Math.floor(Date.now() / 1000)
        const claimableAmount = this.withdrawals
            .reduce((res, withdrawal) => {
                if (now >= Number(withdrawal.endTime)) {
                    res += withdrawal.amount
                }
                return res;
            }, 0n)

        return claimableAmount.toString()
    }

    get claimableIndices() {
        const now = Math.floor(Date.now() / 1000)
        const result = []
        for (let i = 0; i < this.withdrawals.length; i++) {
            if (now >= Number(this.withdrawals[i].endTime)) {
                result.push(i)
            }
        }
        return result
    }

    get isClaimAvailable() {
        return BigInt(this.claimableWithdrawalsAmount) > 0n
    }


    resetState() {
        this.withdrawals = []
    }

    setWithdrawals(withdrawals: ILockWithdrawal[]) {
        this.withdrawals = withdrawals
    }

    async fetchWithdrawals(nrsLockWithdrawalTimelockContract: any, userAddress: string) {
        try {
            this.latestUpdateAt = Date.now()

            if (userAddress && nrsLockWithdrawalTimelockContract) {
                const withdrawals = await nrsLockWithdrawalTimelockContract.read.getAllUserWithdrawals([userAddress])
                this.setWithdrawals(withdrawals);
            }
        } catch (error) {
            console.error('Failed to fetchWithdrawals:', error);
        }
    }

    async fetchWithdrawalsThrottled(nrsWithdrawalTimelockContract: any, userAddress: string) {
        if (this.latestUpdateAt === 0 || Date.now() - this.latestUpdateAt > 5000) {
            await this.fetchWithdrawals(nrsWithdrawalTimelockContract, userAddress)
        }
    }
}

export const depositWithdrawalLockStore = new DepositWithdrawalLockStore();
